import { getConnectionId } from './lib/utils/getConnectionId';
import { getHasSharedWorkerSupport } from './lib/utils/getHasSharedWorkerSupport';
import { SharedWorkerMessagingClient } from './lib/host/SharedWorkerMessagingClient';
import { ConnectionStatusTypes } from './lib/types/ConnectionStatuses';
export class VersionedSharedWorkerHost {
  constructor(options) {
    this.isInitialized = false;
    this.connectionId = getConnectionId();
    this._disconnected = false;
    this.disconnect = e => {
      if (this._disconnected) return;
      this._disconnected = true;
      if (this._clientOptions.debug) this._clientOptions.debug('Disconnecting from SharedWorker');
      if (!e) {
        window.removeEventListener('beforeunload', this.disconnect);
        window.removeEventListener('unload', this.disconnect);
      }
      this._onDisconnect();
      if (this._client) this._client.connectionStatus = ConnectionStatusTypes.DISCONNECTING;
      if (this._client) this._client.close();
    };
    this.sendMessage = message => {
      if (!this._client || !this.isInitialized) {
        this._clientOptions.onMessageError(new Error('Message Client does not exist or is not ready'));
        return;
      }
      if (this._clientOptions.debug) this._clientOptions.debug(`Sending message to SharedWorker ${message.type}`, message);
      this._client.sendMessage(message);
    };
    this.initialize = (connectionId, SharedWorkerClient = SharedWorkerMessagingClient) => new Promise((resolve, reject) => {
      if (this.isInitialized) return;
      this.isInitialized = true;
      if (!getHasSharedWorkerSupport()) {
        if (this._clientOptions.debug) {
          this._clientOptions.debug('SharedWorkers are unsupported');
        }
        reject(new Error(`SharedWorkers are ${ConnectionStatusTypes.UNSUPPORTED}`));
        return;
      }
      if (connectionId) this.connectionId = connectionId;
      this._client = new SharedWorkerClient(Object.assign({}, this._clientOptions, {
        connectionId: this.connectionId
      }));
      window.addEventListener('beforeunload', this.disconnect);
      window.addEventListener('unload', this.disconnect);
      this._client.open().then(resolve).catch(e => {
        if (this._clientOptions.debug) this._clientOptions.debug('Failed to setup SharedWorker');
        reject(e);
      });
    });
    const {
      portalId,
      version,
      name,
      sharedWorkerUrl,
      onMessage,
      onVersionWorkerStatusUpdate,
      onDisconnect,
      onMessageError,
      getAdditionalRegistrationInformation,
      debug
    } = Object.assign({
      getAdditionalRegistrationInformation: () => ({}),
      onDisconnect: () => {},
      onMessage: () => {},
      onMessageError: (__err, __ex) => {}
    }, options);
    this.appDataVersion = version;
    this._clientOptions = {
      portalId,
      onMessage,
      onMessageError,
      initialClientVersion: version,
      appDataVersion: this.appDataVersion,
      name,
      onVersionWorkerStatusUpdate,
      getAdditionalRegistrationInformation,
      sharedWorkerUrl,
      debug
    };
    this._onDisconnect = onDisconnect;
  }
  get connectionStatus() {
    if (!this._client) return ConnectionStatusTypes.UNINITIALIZED;
    return this._client.connectionStatus;
  }
}